import Button from '@jetbrains/ring-ui/components/button/button'
import React, {memo, useRef} from 'react'
import {Transition} from 'react-transition-group'

import Icon from '../../../../../common/Icon/Icon'

import styles from './SuggestionMessage.css'

type Props = {
  message: string
  actionText: string
  cancelText?: string
  visible?: boolean
  onActionClick: () => void
  onCancelClick?: () => void
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}
const TRANSITIONS = {
  entering: {maxHeight: 0, opacity: 0},
  entered: {transition: 'all 0.3s ease-in', maxHeight: '64px', opacity: 1},
  exiting: {transition: 'all 0.3s ease-in', maxHeight: 0, opacity: 0},
  exited: {transition: 'all 0.3s ease-in', maxHeight: 0, opacity: 0},
  unmounted: {transition: 'all 0.3s ease-in', maxHeight: 0, opacity: 0},
}

function SuggestionMessage({
  message,
  actionText,
  cancelText = 'Skip it',
  visible,
  onActionClick,
  onCancelClick,
  onMouseEnter,
  onMouseLeave,
}: Props) {
  const nodeRef = useRef(null)

  return (
    <Transition appear unmountOnExit nodeRef={nodeRef} in={visible} timeout={300}>
      {state => (
        <div
          className={styles.container}
          ref={nodeRef}
          style={{...TRANSITIONS[state]}}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          <Icon name="sparkles-36px" className={styles.icon} />
          <div>
            <div className={styles.message}>{message}</div>
            <Button text className={styles.mainAction} onClick={onActionClick}>
              {actionText}
            </Button>
            <Button text className={styles.secondaryAction} onClick={onCancelClick}>
              {cancelText}
            </Button>
          </div>
        </div>
      )}
    </Transition>
  )
}

export default memo<Props>(SuggestionMessage)
